import { render, staticRenderFns } from "./NavEventCalendar.vue?vue&type=template&id=13cb502a&"
import script from "./NavEventCalendar.vue?vue&type=script&lang=js&"
export * from "./NavEventCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports